var _g, _g2, _g3, _g4, _g5, _g6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContractActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "contract",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.357,
    height: 16.358,
    viewBox: "0 0 16.357 16.358",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_37739",
    "data-name": "Group 37739",
    transform: "translate(9.56)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37738",
    "data-name": "Group 37738"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77925",
    "data-name": "Path 77925",
    d: "M302.107,2.793a1.429,1.429,0,0,0-.421-1.016L300.33.421A1.47,1.47,0,0,0,299.3,0h-.082V2.875h2.885V2.793Z",
    transform: "translate(-299.222)",
    fill: "#fff"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_37741",
    "data-name": "Group 37741"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37740",
    "data-name": "Group 37740"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77926",
    "data-name": "Path 77926",
    d: "M8.752,9.889a1.924,1.924,0,0,1,.461-.748L12.457,5.91V3.834H9.09a.466.466,0,0,1-.464-.479V0H1.438A1.439,1.439,0,0,0,0,1.438V14.92a1.439,1.439,0,0,0,1.438,1.438h9.569a1.45,1.45,0,0,0,1.45-1.438V11.343l-.527.514a1.906,1.906,0,0,1-.745.46l-1.524.509-.232.013A1.2,1.2,0,0,1,8.294,11.26ZM2.4,8.626H7.173a.479.479,0,0,1,0,.958H2.4a.479.479,0,0,1,0-.958ZM1.917,7.188A.479.479,0,0,1,2.4,6.709H7.173a.479.479,0,1,1,0,.958H2.4A.479.479,0,0,1,1.917,7.188Zm0,3.834a.479.479,0,0,1,.479-.479H7.173a.479.479,0,1,1,0,.958H2.4A.479.479,0,0,1,1.917,11.022Zm7.173,2.4a.479.479,0,0,1,0,.958H6.214a.479.479,0,0,1,0-.958ZM2.4,5.751a.479.479,0,1,1,0-.958H9.09a.479.479,0,1,1,0,.958Z",
    fill: "#fff"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_37743",
    "data-name": "Group 37743",
    transform: "translate(9.19 10.313)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37742",
    "data-name": "Group 37742"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77927",
    "data-name": "Path 77927",
    d: "M288.092,322.808l-.417,1.251a.24.24,0,0,0,.3.3l1.25-.418Z",
    transform: "translate(-287.663 -322.808)",
    fill: "#fff"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_37745",
    "data-name": "Group 37745",
    transform: "translate(10.186 6.368)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37744",
    "data-name": "Group 37744"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77928",
    "data-name": "Path 77928",
    d: "M321.976,199.307l-3.156,3.156,1.361,1.361,3.156-3.156Z",
    transform: "translate(-318.82 -199.307)",
    fill: "#fff"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_37747",
    "data-name": "Group 37747",
    transform: "translate(14.02 4.727)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37746",
    "data-name": "Group 37746"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77929",
    "data-name": "Path 77929",
    d: "M440.875,148.215a1,1,0,0,0-1.36,0l-.7.7,1.361,1.361.7-.7A.965.965,0,0,0,440.875,148.215Z",
    transform: "translate(-438.819 -147.949)",
    fill: "#fff"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_37750",
    "data-name": "Group 37750",
    transform: "translate(16.077 6.345)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37749",
    "data-name": "Group 37749"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37748",
    "data-name": "Group 37748"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77930",
    "data-name": "Path 77930",
    d: "M503.215,198.811h0l0,0Z",
    transform: "translate(-503.215 -198.801)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77931",
    "data-name": "Path 77931",
    d: "M503.3,198.679l0,0Z",
    transform: "translate(-503.3 -198.673)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77932",
    "data-name": "Path 77932",
    d: "M503.436,198.6Z",
    transform: "translate(-503.429 -198.602)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContractActive);
export default __webpack_public_path__ + "static/media/contractActive.6893914796528d001dfe888ce0c28f75.svg";
export { ForwardRef as ReactComponent };